var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.97 18.385L14.614 15.029C13.1661 15.6882 11.5908 16.0204 10 16.002C8.35988 16.0223 6.73671 15.6684 5.254 14.967C4.10468 14.4062 3.07264 13.6317 2.213 12.685C1.30049 11.7068 0.583297 10.5633 0.1 9.31595L0 9.00195L0.105 8.68595C0.82781 6.84224 2.04426 5.23312 3.621 4.03495L1 1.41395L2.413 0.00195312L19.382 16.971L17.972 18.385H17.97ZM5.036 5.45095C3.75792 6.34687 2.74865 7.57466 2.117 9.00195C3.47142 12.1269 6.59587 14.1086 10 14.002C11.0498 14.0106 12.0936 13.8415 13.087 13.502L11.287 11.702C10.8863 11.8984 10.4462 12.0009 10 12.002C8.34746 11.9916 7.01037 10.6545 7 9.00195C7.00048 8.55472 7.10309 8.1135 7.3 7.71195L5.036 5.45095ZM17.852 12.612L16.46 11.221C17.0456 10.5589 17.5256 9.8104 17.883 9.00195C16.5304 5.87553 13.4047 3.89303 10 4.00195C9.753 4.00195 9.505 4.01095 9.265 4.02795L7.5 2.26095C8.32163 2.08519 9.15979 1.99835 10 2.00195C11.6401 1.9816 13.2633 2.33557 14.746 3.03695C15.8953 3.59769 16.9274 4.37215 17.787 5.31895C18.6991 6.29592 19.4163 7.43803 19.9 8.68395L20 9.00195L19.895 9.31795C19.4268 10.536 18.7342 11.6554 17.853 12.618L17.852 12.612Z",
    fill: "#AEB1B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/closeEye.cd88e1ae10e707f4b723b64b1e39b226.svg";
export { ForwardRef as ReactComponent };